"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = exports.clearIsLoaded = exports.getIsLoaded = exports.setDirty = exports.trySave = exports.getLastFilename = void 0;
var settings_sidecar_1 = require("@engine/settings-sidecar");
var imports_1 = require("@lib/imports");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageTileData_sidecar_1 = require("@voyage/tilemap/voyageTileData-sidecar");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
var voyageTilemapPart_sidecar_1 = require("@voyage/tilemap/voyageTilemapPart-sidecar");
var voyageJsonServerInterface_sidecar_1 = require("./voyageJsonServerInterface-sidecar");
var namespace = 'voyage-ship-saver';
var _isDirty = false;
var _saveDelay = 0;
var _isLoaded = false;
var _lastFilename = 'untitled';
function getLastFilename() {
    return _lastFilename;
}
exports.getLastFilename = getLastFilename;
function trySave() {
    if (_isDirty) {
        var dt = common_sidecar_1.common.getUpdateDelta();
        _saveDelay += dt;
        if (_saveDelay > 1) {
            doSave();
            _isDirty = false;
        }
    }
}
exports.trySave = trySave;
function setDirty() {
    _isDirty = true;
    _saveDelay = 0;
}
exports.setDirty = setDirty;
function getIsLoaded() {
    return _isLoaded;
}
exports.getIsLoaded = getIsLoaded;
function clearIsLoaded() {
    _isLoaded = false;
}
exports.clearIsLoaded = clearIsLoaded;
function doSave() {
    var tiles = getTilesData();
    // voyageJsonServerInterface.save(_lastFilename, { tiles })
}
function getTilesData() {
    var tm = voyageTilemap_sidecar_1.voyageTilemap.get();
    var tiles = {
        w: tm.width,
        h: tm.height,
        v: 1,
        t: [],
    };
    imports_1.l.forEach(tm.parts, function (c) {
        var _a;
        (_a = tiles.t).push.apply(_a, [
            c.tile1.type,
            c.subTileIdx1,
            c.colorIdx1,
            c.tile2.type,
            c.subTileIdx2,
            c.colorIdx2,
            c.tile3.type,
            c.subTileIdx3,
            c.colorIdx3,
        ]);
        if (c.tile3.includesText) {
            tiles.t.push(c.text3);
        }
    });
    return tiles;
}
function load(filename) {
    return; // disable
    _isLoaded = false;
    _lastFilename = filename;
    settings_sidecar_1.settings.update({ filename: _lastFilename });
    voyageJsonServerInterface_sidecar_1.voyageJsonServerInterface.loadAsync(filename).then(function (data) {
        if (data && data.tiles) {
            console.log(namespace, 'loaded', filename, data.tiles.w, data.tiles.h);
            var tData = data.tiles.t;
            var tm = voyageTilemap_sidecar_1.voyageTilemap.get();
            var idx = 0;
            for (var j = 0; j < tm.height; j++) {
                for (var i = 0; i < tm.width; i++) {
                    var t = voyageTilemap_sidecar_1.voyageTilemap.getUnsafe(i, j);
                    voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(t, voyageTileData_sidecar_1.voyageTileData.get(tData[idx]), tData[idx + 1], tData[idx + 2]);
                    idx += 3;
                    voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(t, voyageTileData_sidecar_1.voyageTileData.get(tData[idx]), tData[idx + 1], tData[idx + 2]);
                    idx += 3;
                    voyageTilemapPart_sidecar_1.voyageTilemapPart.setTile(t, voyageTileData_sidecar_1.voyageTileData.get(tData[idx]), tData[idx + 1], tData[idx + 2]);
                    idx += 3;
                    if (t.tile3.includesText) {
                        voyageTilemapPart_sidecar_1.voyageTilemapPart.setText(t, '' + tData[idx]);
                        idx++;
                    }
                    else {
                        voyageTilemapPart_sidecar_1.voyageTilemapPart.setText(t, '');
                    }
                }
            }
        }
        _isLoaded = true;
    });
}
exports.load = load;
